/**
 * Created by m.igrachev on 10/14/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/PreloaderDocumentedProps";

import("./Preloader.less");

export default class Preloader extends React.Component {
    render() {
        let status = this.props.status || "show";
        let extraClasses = this.props.extraClasses || "";
        let containerClass = extraClasses + " tq-preloader-container";
        let loadingElementClass = "";
        let visible;

        switch (status) {
            case "show":
            case "waitContentRender":
                visible = true;
                loadingElementClass = " tq-load";
                if (this.props.fadeAnimation) {
                    loadingElementClass = " tq-preloader-fade-in";
                }
                break;
            case "fadein":
                visible = true;
                loadingElementClass = " tq-load";
                if (this.props.fadeAnimation) {
                    loadingElementClass = " tq-preloader-fade-in";
                }
                break;
            case "fadeout":
                visible = true;
                loadingElementClass = " tq-unload";
                if (this.props.fadeAnimation) {
                    loadingElementClass = " tq-preloader-fade-out";
                }
                break;
            default:
                visible = false;
                break;
        }

        let preloaderMaskClass, spinner, itemClass, style;
        if (visible) {
            containerClass += this.props.small ? " tq-small" : "";
            containerClass += this.props.global ? " tq-global-preloader" : "";
            containerClass +=
                React.Children.count(this.props.children) === 0 && !this.props.global
                    ? " tq-init"
                    : "";
            preloaderMaskClass = "tq-preloader-mask" + loadingElementClass;
            itemClass = "tq-preloader-item" + loadingElementClass;

            if (this.props.customContent) {
                spinner = this.props.customContent;
            } else {
                spinner = (
                    <div className="tq-spinner">
                        <div className="tq-border-circle">
                            <div className="tq-double-bounce1" />
                            <div className="tq-double-bounce2" />
                        </div>
                    </div>
                );
            }

            if (this.props.minHeight) {
                style = { minHeight: this.props.minHeight };
            }
        }

        return (
            <div className={visible ? containerClass : null} style={style}>
                <div className={preloaderMaskClass} />
                {this.props.children}
                {visible && <div className={itemClass}>{spinner}</div>}
            </div>
        );
    }
}

Preloader.displayName = "Preloader";

Preloader.propTypes = {
    status: PropTypes.oneOf(["show", "waitContentRender", "fadein", "fadeout", "hide", "wait"]),
    global: PropTypes.bool,
    small: PropTypes.bool,
    minHeight: PropTypes.number,
    fadeAnimation: PropTypes.bool,
    preloaderType: PropTypes.string,
    label: PropTypes.string,
    extraClasses: PropTypes.string,
    customContent: PropTypes.element
};

Preloader.documentedProps = documentedProps;
